/**
 * THE MOUNT. One root, one router, and nothing else.
 *
 * The stylesheet is linked from index.html rather than imported here, so the
 * page has its ground, its type and its density before the first component
 * mounts — and so exactly one copy of it exists.
 */
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./screens/app.js";
import { ClientRequestPage } from "./screens/clientRequest.js";
import { JoinPage } from "./screens/join.js";
import { RegisterPage } from "./screens/register.js";
import { ForgotPasswordPage, ResetPasswordPage } from "./screens/password.js";

/**
 * A CLIENT'S REQUEST LINK (`/r#<token>`, R10.1) is decided here, before the app
 * mounts: the client has no account, so the sign-in gate — and its session
 * call — must never stand between them and the one request they were sent.
 */
createRoot(document.getElementById("root")!).render(
  window.location.pathname === "/r" ? (
    <ClientRequestPage />
  ) : window.location.pathname === "/join" ? (
    /* A colleague's invitation (`/join#<token>`, 0034): the person has no account yet. */
    <JoinPage />
  ) : window.location.pathname === "/forgot" ? (
    /* Forgot your password? (0041): the person cannot sign in, so no session call. */
    <ForgotPasswordPage />
  ) : window.location.pathname === "/reset" ? (
    /* The emailed link (`/reset#<token>`, 0041): the token is the credential. */
    <ResetPasswordPage />
  ) : window.location.pathname === "/register" ? (
    /* Registering interest (`/register?from=<source>`, 0040): before anyone has an account. */
    <RegisterPage />
  ) : (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  )
);
